import { Outlet } from 'react-router';
import { CookieBanner } from '../components/cookies';

export default function RootLayout() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Outlet />

      {/* Cookie Consent Banner */}
      <CookieBanner />
    </div>
  );
}
